function throttle<T extends unknown[]>(callback: (...args: T) => void, timeout: number): (...args: T) => void {
    let waiting = false;

    return function throttled<This>(this: This, ...args: T) {
        if (!waiting) {
            callback.apply(this, args);
            waiting = true;
            window.setTimeout(() => {
                waiting = false;
            }, timeout);
        }
    };
}

function throttleAndDebounce<T extends unknown[]>(
    callback: (...args: T) => void,
    throttleTimeout: number,
    debounceTimeout: number
): (...args: T) => void {
    let waiting = false;
    let debounceTimer: number | undefined;
    let lastArgs: { args: T; context: unknown; } | undefined;

    return function throttledAndDebounced(this: unknown, ...args: T) {
        lastArgs = { args, context: this };

        if (!waiting) {
            callback.apply(this, args);
            waiting = true;
            window.setTimeout(() => {
                waiting = false;
            }, throttleTimeout);
        }

        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(() => {
            if (lastArgs) {
                callback.apply(lastArgs.context, lastArgs.args);
                lastArgs = undefined;
            }
        }, debounceTimeout);
    };
}

export default throttle;
export {
    throttleAndDebounce
};
